// ── V149: 오늘의 작업 — 계산 도우미 (화면·인쇄 같이 씀) ─────────────────────────
// 레시피 재료 수량은 '총 산출량(total_output)' 기준이다 (RecipeView.calcRatio와 같은 식).
//   만들 양 495g, 총 산출량 495g → 재료 그대로 / 990g → 재료 2배
import { unitToZh } from '../i18n/units';

const pad = (n) => String(n).padStart(2, '0');

/** 이 기기 날짜 기준 'YYYY-MM-DD' */
export const todayKey = (d = new Date()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const newWorkId = () => 'w' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

const WEEK_KO = ['일', '월', '화', '수', '목', '금', '토'];
const WEEK_ZH = ['日', '一', '二', '三', '四', '五', '六'];

/** '2026-10-24' → '10월 24일 (토)' / '10月24日 星期六' */
export function fmtDay(key, lang = 'ko', withYear = false) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(key || ''));
  if (!m) return String(key || '');
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const mo = d.getMonth() + 1; const da = d.getDate(); const w = d.getDay();
  if (lang === 'zh') return `${withYear ? `${d.getFullYear()}年` : ''}${mo}月${da}日 星期${WEEK_ZH[w]}`;
  return `${withYear ? `${d.getFullYear()}년 ` : ''}${mo}월 ${da}일 (${WEEK_KO[w]})`;
}

/** 레시피 기준량(g) — 총 산출량 → 총 투입량 → 재료 합 순서로 */
export function recipeBase(r) {
  const out = Number(r?.total_output) || 0;
  if (out > 0) return out;
  const inp = Number(r?.total_input) || 0;
  if (inp > 0) return inp;
  const sum = (r?.ingredients || []).reduce((s, i) => s + (Number(i?.qty) || 0), 0);
  return sum > 0 ? sum : 0;
}

/** 만들 양(g)에 맞춘 재료 목록 [{ name, qty, unit }] */
export function scaleIngredients(r, grams) {
  const base = recipeBase(r);
  const ratio = base > 0 ? (Number(grams) || 0) / base : 0;
  return (r?.ingredients || [])
    .filter(i => i && String(i.name || '').trim())
    .map(i => ({ name: String(i.name).trim(), unit: String(i.unit || '').trim() || 'g', qty: (Number(i.qty) || 0) * ratio }));
}

// 12.5 → "12.5", 12 → "12", 3.333 → "3.3", 0.25 → "0.25"
export function fmtNum(n) {
  const v = Number(n) || 0;
  if (v === 0) return '0';
  if (Math.abs(v - Math.round(v)) < 0.05 && Math.abs(v) >= 1) return String(Math.round(v));
  if (Math.abs(v) >= 10) return v.toFixed(0);
  if (Math.abs(v) >= 1) return v.toFixed(1).replace(/\.0$/, '');
  return v.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
}

const trimDec = (s) => s.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');

/** 양 표시 — 1000g 이상은 kg, 1000ml 이상은 L. 중국어 화면은 한글 단위를 중국어로 */
export function fmtAmount(q, unit = 'g', lang = 'ko') {
  const u = String(unit || '').trim() || 'g';
  const v = Number(q) || 0;
  if ((u === 'g' || u === 'ml') && v >= 1000) return `${trimDec((v / 1000).toFixed(2))}${u === 'g' ? 'kg' : 'L'}`;
  const shown = lang === 'zh' ? (unitToZh(u) || u) : u;
  return `${fmtNum(v)}${shown}`;
}

/** 여러 작업에 필요한 재료 합계 — 이름·단위가 같으면 더한다 */
export function sumIngredients(tasks) {
  const m = new Map();
  for (const { recipe, grams } of tasks || []) {
    if (!recipe) continue;
    for (const ing of scaleIngredients(recipe, grams)) {
      const key = `${ing.name.replace(/\s+/g, '')}|${ing.unit}`;
      const cur = m.get(key);
      if (cur) cur.qty += ing.qty;
      else m.set(key, { ...ing });
    }
  }
  return [...m.values()];
}
